<template>
  <section class="flex flex-col bg-gray-50">
    <div class="prose px-6 py-5 text-sm text-gray-400">
      <h1 class="text-xl font-medium text-secondary [&>a]:no-underline [&>a]:text-secondary cursor-pointer"><a @click="navigate('/reports')"><u>Indberetninger</u></a> / {{ reportTypeDisplay }}</h1>
    </div>
  </section>
  <section class="dynamic">
    <component v-for="componentName in reportDetailsComponents" :is="componentName" :key="componentName"></component>
  </section>
</template>

<script lang='ts'>
import { computed, defineComponent, defineAsyncComponent, Ref, watch } from 'vue'
import { getValidReportType } from '@/core/utils'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import WeeklyActivity from '@/components/report/weekly-activity-log.vue'
import { ReportType } from '@/models/report.model'

const componentMap: any = {
  WeeklyActivity
}

export default defineComponent({
  name: 'reportWeek',
  setup () {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const typeParam = route.params.type as string
    const type = getValidReportType(typeParam)

    const updateReportType = () => {
      if (type != null) {
        store.dispatch('report/setReportType', type)
      } else {
        router.push('/')
      }
    }
    watch(() => route.params.type, updateReportType, { immediate: true })

    const navigate = (path: string) => {
      router.push(path)
    }

    const reportTypeDisplay = computed(() => {
      switch (type) {
        case ReportType.TIME:
          return 'Timer'
        case ReportType.TRANSPORT:
          return 'Transport'
        case ReportType.SICK:
          return 'Sygdom'
        case ReportType.DIET:
          return 'Diæt'
        default:
          return ''
      }
    })

    const reportDetailsComponents = computed(() => {
      const componentNames = store.getters['report/reportWeekComponents']
      return componentNames.map((name: string) => {
        const component = componentMap[name]
        return component
      })
    })

    return { reportTypeDisplay, reportDetailsComponents, navigate }
  }
})
</script>
